import script from "./DoctorInvite.vue?vue&type=script&lang=ts&setup=true"
export * from "./DoctorInvite.vue?vue&type=script&lang=ts&setup=true"

import "./DoctorInvite.vue?vue&type=style&index=0&id=b496a7ca&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b496a7ca"]])

export default __exports__